import React from "react"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import { showNotificationWithTimeout } from "../../_actions/adminAlertActionCreator"
import Loader from "../../common/Loader"
import NotFound from "../../common/NotFound"
import { API } from "../../api"

class RedirectCheckoutCoinsph extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fetching: true,
      orderUUID: null
    }
  }

  redirectByInvoiceId = async () => {
    try {
      const response = await API.get(
        `checkout/redirect/coinsph${this.props.location.search}`
      )
      const orderUUID = response.data.order_uuid
      this.setState(state => ({
        ...state,
        orderUUID: orderUUID
      }))
      return Promise.resolve()
    } catch (error) {
      console.log(error.response)
      return Promise.reject()
    } finally {
      this.setState(state => ({ ...state, fetching: false }))
    }
  }

  async componentDidMount() {
    await this.redirectByInvoiceId()
  }

  render() {
    const { fetching, orderUUID } = this.state
    return (
      <div className="RedirectCheckoutCoinsph">
        {(fetching && <Loader />) ||
          (!fetching &&
            orderUUID && (
              <Redirect
                to={{
                  pathname: `/checkout/${orderUUID}`,
                  state: { from: this.props.location }
                }}
              />
            )) || <NotFound />}
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  showAlert: alert => {
    showNotificationWithTimeout(dispatch, alert)
  }
})

export default connect(
  null,
  mapDispatchToProps
)(RedirectCheckoutCoinsph)
